import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import './components/common/WhatsAppFloatingButton';

// Layout Component
import Layout from './components/layout/Layout';

// Eagerly loaded components for immediate rendering
import LoadingSpinner from './components/common/LoadingSpinner';

// Context Providers
import { ThemeProvider } from './context/ThemeContext';
import WhatsAppFloatingButton from './components/common/WhatsAppFloatingButton';

// Lazy loaded page components for code splitting
const HomePage = lazy(() => import('./pages/HomePage'));
const SolutionsPage = lazy(() => import('./pages/SolutionsPage'));
const SolutionDetailPage = lazy(() => import('./pages/SolutionDetailPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const PortfolioPage = lazy(() => import('./pages/PortfolioPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const NewsPage = lazy(() => import('./pages/NewsPage'));
const NewsDetailPage = lazy(() => import('./pages/NewsDetailPage'));

// const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Layout>
          <Suspense fallback={
            <div className="flex justify-center items-center h-64">
              <LoadingSpinner />
            </div>
          }>
            <Routes>
              {/* Home page */}
              <Route path="/" element={<HomePage />} />
                {/* Solution pages */}
              <Route path="/solutions" element={<SolutionsPage />} />
              <Route path="/solutions/category/:categoryId" element={<SolutionsPage />} />
              <Route path="/solutions/product/:productId" element={<SolutionDetailPage />} />
              
              {/* About pages */}
              <Route path="/about" element={<AboutPage />} />
              
              {/* Portfolio page */}
              <Route path="/portfolio" element={<PortfolioPage />} />
              
              {/* News pages */}
              <Route path="/news" element={<NewsPage />} />
              <Route path="/news/:slug" element={<NewsDetailPage />} />
              
              {/* Contact pages */}
              <Route path="/contact" element={<ContactPage />} />              
              {/* Redirect /home to / */}
              <Route path="/home" element={<Navigate replace to="/" />} />
              
              {/* 404 page */}
              {/* <Route path="*" element={<NotFoundPage />} /> */}            </Routes>
          </Suspense>

        </Layout>
        
        {/* Debug Panel - only shows in development or when enabled */}
        {/* <APIDebugPanel /> */}
      </Router>
      <WhatsAppFloatingButton />
    </ThemeProvider>

  );
}

export default App;
